<template>
  <div class="pie-chart-container">
    <PartTitle title="竹产动态" />
    <div class="body-box">
      <div class="chart-box" ref="pieChartRef"></div>
      <div class="text-box">
        <dl v-for="(item,index) in pieData" :key="index">
          <dt>{{ item.title }}</dt>
          <dd>
            <b>{{ item.data }}</b>
            <span>{{ item.unit }}</span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import PartTitle from './PartTitle.vue';

export default {
  name: 'PieChart',
  components: { PartTitle },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  watch:{
    items: {
      handler(val) {
        if (val.length > 0) {
          this.pieData = val;
          this.initChart();
        }
      },
    }
  },

  data() {
    return {
      chartInstance: null,
      pieData: [],
      angle: 0,
      animationFrameId: null,
      staticOption: {
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b}: {c} ({d}%)',
          formatter: function (params, ticket, callback) {
            return params.data.name + ': ' + params.data.value + params.data.unit;
          }
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: 'pie',
            radius: ['30%', '66%'],
            label: {
              show: false,
              position: 'center',
            },
            animationDuration: 0,
            animationEasing: 'cubicOut',
            data: [
              // {
              //   value: 1048,
              //   name: '竹材产量',
              //   itemStyle: {
              //     borderWidth: 5,
              //     shadowBlur: 10,
              //     color: '#FF801C',
              //     borderColor: '#FF801C',
              //     shadowColor: '#FF801C',
              //   },
              // },
              // {
              //   value: 735,
              //   name: '竹笋产量',
              //   itemStyle: {
              //     borderWidth: 5,
              //     shadowBlur: 10,
              //     color: '#00FEFF',
              //     borderColor: '#00FEFF',
              //     shadowColor: '#00FEFF',
              //   },
              // },
            ],
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    // this.initChart();
    this.animate();
  },
  beforeDestroy() {
    // 清理资源


  },
  methods: {
    initChart() {
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
      this.chartInstance = this.$echarts.init(this.$refs.pieChartRef);

      this.pieData[0].color = "#FF801C";
      this.pieData[1].color = "#00FEFF";
      this.pieData.forEach(item => {
        this.staticOption.series[0].data.push({
          value: item.data,
          name: item.title,
          unit:item.unit,
          itemStyle: {
            borderWidth: 5,
            shadowBlur: 10,
            color: item.color,
            borderColor: item.color,
            shadowColor: item.color,
          },
        });
      });

      // 首次设置完整的option，包括饼图和动态元素
      this.chartInstance.setOption({
        ...this.staticOption,
        series: [...this.staticOption.series, ...this.getDynamicSeries()],
      });
    },

    animate() {
      this.angle = (this.angle + 1) % 360;
      this.updateDynamicElements();
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      this.animationFrameId = requestAnimationFrame(this.animate);
    },

    updateDynamicElements() {
      if (!this.chartInstance) return;

      const dynamicOption = {
        series: this.getDynamicSeries(),
      };
      this.chartInstance.setOption(dynamicOption, false);
    },

    getDynamicSeries() {
      const series = [];
      const colors = [
        { line: '#00FEFF', point: '#00FEFF', start: 0, end: 90, rIndex: 2.2 },
        { line: 'red', point: 'red', start: 180, end: 270, rIndex: 2.2 },
        { line: 'yellow', point: 'yellow', start: 270, end: 40, rIndex: 2.46, invert: true },
        { line: 'pink', point: 'pink', start: 90, end: 220, rIndex: 2.46, invert: true },
      ];

      colors.forEach((color, idx) => {
        // 添加线
        series.push({
          name: `ring-line-${idx}`,
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: (params, api) => {
            const angleMod = color.invert ? -this.angle : this.angle;
            return {
              type: 'arc',
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: Math.min(api.getWidth(), api.getHeight()) / color.rIndex,
                startAngle: ((color.start + angleMod) * Math.PI) / 180,
                endAngle: ((color.end + angleMod) * Math.PI) / 180,
              },
              style: {
                stroke: color.line,
                fill: 'transparent',
                lineWidth: 1.5,
              },
              silent: true,
            };
          },
          data: [0],
        });

        // 添加点
        series.push({
          name: `ring-point-${idx}`,
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: (params, api) => {
            const angleMod = color.invert ? -this.angle : this.angle;
            const x0 = api.getWidth() / 2;
            const y0 = api.getHeight() / 2;
            const r = Math.min(api.getWidth(), api.getHeight()) / color.rIndex;
            const pointAngle = color.start + angleMod;
            const point = this.getCirlPoint(x0, y0, r, pointAngle);

            return {
              type: 'circle',
              shape: {
                cx: point.x,
                cy: point.y,
                r: 4,
              },
              style: {
                stroke: color.point,
                fill: color.point,
              },
              silent: true,
            };
          },
          data: [0],
        });
      });

      return series;
    },

    getCirlPoint(x0, y0, r, angle) {
      let x1 = x0 + r * Math.cos((angle * Math.PI) / 180);
      let y1 = y0 + r * Math.sin((angle * Math.PI) / 180);
      return {
        x: x1,
        y: y1,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.pie-chart-container {
  flex: 1;
  .body-box {
    width: 98%;
    margin: 0 auto;
    height: calc(100% - 52px);
    display: flex;
    flex-direction: row;
    align-items: center;

    .chart-box {
      flex: 1.5;
      height: 100%;
    }
    .text-box {
      flex: 1;
      color: #ffffff;
      font-size: 15px;
      margin-left: 30px;

      dl {
        &:nth-child(2) {
          margin-top: 20px;
        }
        dt {
          font-size: 16px;
        }
        dd {
          b {
            font-size: 20px;
          }
          span {
            color: #0f92ff;
            padding-left: 10px;
          }
        }
      }
    }
  }
}
</style>
